const ArrowLitleLeftIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" {...props}>
    <path fill="#C6CDD0" fillRule="evenodd" d="M6 .6L7.4 2l-4 4 4 4L6 11.4.6 6z" />
  </svg>
)

export default ArrowLitleLeftIcon
